import React from 'react';
import { motion } from 'framer-motion';
import { highlightTerms } from '../highlightTerms';
import { Timer, Gauge, TrendingUp, Zap } from 'lucide-react';

export const TestingSlide = ({ slide }) => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.15, delayChildren: 0.2 },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: { opacity: 1, scale: 1, transition: { duration: 0.5, ease: 'easeOut' } },
  };

  const icons = [Timer, Gauge, TrendingUp, Zap];

  return (
    <div
      className="h-full w-full flex flex-col justify-center items-center px-8 md:px-12 lg:px-20 py-12"
      data-testid={`slide-${slide.id}`}
    >
      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        className="max-w-5xl w-full"
      >
        <motion.h2
          variants={itemVariants}
          className="pres-font-heading text-4xl md:text-5xl lg:text-6xl font-black uppercase tracking-tight text-white mb-10 text-center"
        >
          {highlightTerms(slide.title)}
        </motion.h2>

        <div className="grid grid-cols-2 gap-5 mb-10">
          {slide.tests?.map((test, idx) => {
            const Icon = icons[idx % icons.length];
            return (
              <motion.div
                key={idx}
                variants={itemVariants}
                className="group"
              >
                <div className="relative bg-[#2A1D45]/60 backdrop-blur-md border-2 border-[#D31113]/50 rounded-2xl p-6 md:p-8 hover:border-[#D31113] transition-all duration-300 text-center">
                  <div className="w-12 h-12 mx-auto mb-4 rounded-xl bg-[#D31113]/20 flex items-center justify-center group-hover:bg-[#D31113]/40 transition-colors">
                    <Icon className="w-6 h-6 text-[#D31113]" />
                  </div>
                  <h3 className="pres-font-heading text-xl md:text-2xl font-bold text-white uppercase mb-3">
                    {test.name}
                  </h3>
                  <p className="font-sans text-sm md:text-base text-gray-300">
                    Measures: <span className="text-[#D31113] font-semibold">{highlightTerms(test.measures)}</span>
                  </p>
                </div>
              </motion.div>
            );
          })}
        </div>

        {slide.keyLine && (
          <motion.div
            variants={itemVariants}
            className="text-center"
          >
            <div className="inline-block py-6 px-10 bg-gradient-to-r from-[#D31113]/20 via-[#D31113]/10 to-[#D31113]/20 border border-[#D31113]/40 rounded-xl">
              <p className="font-sans text-xl md:text-2xl text-white font-bold">
                {highlightTerms(slide.keyLine)}
              </p>
            </div>
          </motion.div>
        )}
      </motion.div>
    </div>
  );
};
